<template>
<!--成为红娘月老-->
  <div id="yuelao" >
    <van-row  class="my_yuelao">
      <!--<van-col span="24" v-if="yuelao.img">
        <van-image width="100%" height="100%"  fit="contain" :src="yuelao.img" />
      </van-col>-->
      <van-col span="24">
        <img src="../assets/img/rectangle.png" width="100%" height="100%" />
      </van-col>
      <van-col span="22" offset="1">
        <van-col span="24" class="my_yuelao_type">
          <span class="content span_left_down" style="white-space: pre-wrap;" v-html="list.content1"></span>
          <div class="yuelao_1_title">{{ list.title1 }}</div>
        </van-col>
        <van-col span="24" class="my_yuelao_type">
          <div class="yuelao_1_title">{{ list.title2 }}</div>
          <span class="content span_left_down" style="white-space: pre-wrap;" v-html="list.content2"></span>
        </van-col>
        <van-col span="24" class="my_yuelao_type" v-if="list.title3">
          <div class="yuelao_1_title">{{ list.title3 }}</div>
          <van-col span="24" class="my_yuelao_type_name">{{ $t('column.Total_time_of_blind_date')}}{{ yuelao.complete_hours }} {{ $t('other.hour')}}</van-col>
          <van-col span="24" class="my_yuelao_type_center">{{ $t('column.Current_duration')}}：{{ yuelao.over_hours }}</van-col>
          <van-col span="24" class="my_yuelao_type_name">{{ $t('column.Angel_field_deduction')}}</van-col>
          <van-col span="24" class="my_yuelao_type_center">{{$t('column.Currently_deductible')}} {{ yuelao.star_sum }}。</van-col>
          <van-col span="24" class="my_yuelao_type_name">{{$t('column.Couple_deduction')}}</van-col>
          <van-col span="24" class="my_yuelao_type_center">{{$t('column.Current_deduction_lovers')}}：{{ yuelao.locking_sum }}</van-col>
          <van-col span="24" class="my_yuelao_type_name">{{$t('column.Overall_progress')}}</van-col>
          <van-col span="24" class="my_yuelao_percentage">
            <van-slider v-model="percentage" disabled />
          </van-col>
          <van-col span="24" class="my_yuelao_type_center">{{ yuelao.over_hours }} {{$t('column.There_are_still')}}{{ yuelao.surplus_hours }}</van-col>
          <van-col span="24" class="my_yuelao_type_name">{{$t('column.Platform_settlement')}}</van-col>
          <van-col span="24" class="my_yuelao_type_center">{{$t('column.Screenshot_review')}}</van-col>
        </van-col>
        <!-- 成为月老和红娘 -->
        <van-col span="18" offset="3">
          <van-button type="primary" size="large" class="my_information_btn" @click="yuelao_btn" safe-area-inset-bottom v-if="list.is_yuelao_apply === '-1'">{{ $t('btn.apply')}}</van-button>
          <van-button type="primary" size="large" class="my_information_btn" safe-area-inset-bottom v-else-if="list.is_yuelao_apply === 0">{{ $t('btn.Application_sent')}}</van-button>
          <van-button type="primary" size="large" class="my_information_btn" @click="yuelao_btn" safe-area-inset-bottom v-else-if="list.is_yuelao_apply === 2">{{ $t('btn.Reapply')}}</van-button>
          </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast";
  export default {
    filters: {
      getbreak (str) {
        return  (str + '').replace('\\n','<br/>')

      }
    },
    data:function() {
      return {
        percentage: 0,
        list: {
          is_auth: 0,
          is_yuelao_apply: '-1'
        },
        yuelao:{
          'img':'',
          'complete_hours':'0',
          'over_hours':'0',
          'star_sum':'0',
          'locking_sum':'0',
          'surplus_hours':'0',
          'over_hours_sum':'0'
        }
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.yuelao')
    },
    methods: {
      // 导航返回
      convert: function() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        console.log(token);
        axios.get(this.baseUrlApi+"mapi/public/index.php/api/user_api/get_matchmaker_yuelao",{ params:{ uid:uid,token:token }}).then(res =>{
          console.log(res);
          if (res.data.code === 1 ) {
            this.yuelao = res.data.data
          }
          this.list = res.data.list
          if (this.yuelao.over_hours_sum > 0) {
            this.percentage = this.yuelao.over_hours_sum / (this.yuelao.complete_hours*60*60) *100
          }
        })
      },
      yuelao_btn(){
        if(this.list.is_auth === 1 &&  (this.list.is_yuelao_apply === '-1' || this.list.is_yuelao_apply === 2) ) {
          //用户提交申请
          const uid = this.$route.query.uid;
          const token = this.$route.query.token;
          axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/add_ordinary_yuelao", {
            params: {
              uid: uid,
              token: token
            }
          }).then(res => {
            console.log(res);
            Toast(res.data.msg)
            if (res.data.code === 1) {
              this.convert()
            }
          })
        }else if(this.list.is_auth === 0) {
          Toast(this.$t('Tips.Certification_audit_progress'))
        }else{
          // 未认证跳转认证页面
          window.location.href="bogo://yuelao_details_jump"
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/yuelao.vue